// Table columns
export const LXS_BILLING_DOCUMENTS_TABLE_DOCUMENT_ID = 'documentId';
export const LXS_BILLING_DOCUMENTS_TABLE_BILLING_TYPE = 'billingType';
export const LXS_BILLING_DOCUMENTS_TABLE_BILLING_TYPE_TEXT = 'billingTypeText';
export const LXS_BILLING_DOCUMENTS_TABLE_BILLING_DATE = 'billingDate';
export const LXS_BILLING_DOCUMENTS_TABLE_SOLD_TO = 'soldToId';
export const LXS_BILLING_DOCUMENTS_TABLE_SOLD_TO_NAME = 'soldToName';
export const LXS_BILLING_DOCUMENTS_TABLE_DUE_DATE = 'dueDate';
export const LXS_BILLING_DOCUMENTS_TABLE_TOTAL_AMOUNT = 'totalAmount';
export const LXS_BILLING_DOCUMENTS_TABLE_NET_AMOUNT = 'netAmount';
export const LXS_BILLING_DOCUMENTS_TABLE_TAX = 'tax';
export const LXS_BILLING_DOCUMENTS_TABLE_ORDER_NUMBER = 'orderNumber';
export const LXS_BILLING_DOCUMENTS_TABLE_PURCHASE_ORDER_NUMB_EXT = 'purchaseOrderNumbExt';
export const LXS_BILLING_DOCUMENTS_TABLE_SHIP_TO = 'shipTo';
export const LXS_BILLING_DOCUMENTS_TABLE_SHIP_TO_NAME = 'shipToName';
export const LXS_BILLING_DOCUMENTS_TABLE_ACTION = 'action';

export const BILLING_TYPE_URL_PARAM = 'billingType';
export const BILLING_DATE_FROM_URL_PARAM = 'fromDate';
export const BILLING_DATE_TO_URL_PARAM = 'toDate';
